<a *ngIf="store.state.common.userLevels.pages && store.state.common.userLevels.pages.SideNavLevel === 3 && !hideTrigger"
	tooltip="{{ 'tutorial' | translate }}"
	placement="{{ forceTooltipDir ? forceTooltipDir : (this.langIsRTL ? 'left' : 'right') }}"
	class="btn-tutorial cursor-pointer {{showLabel ? 'service-context-menu-item' : ''}}"
	(click)='toggleTutorial()'>
		<i class="far fa-circle-question"></i>
		<span *ngIf="showLabel">{{ 'tutorial' | translate }}</span>
</a>

	<div class="tutorial-layer tutorial-layer-{{position}} {{ !isClosed ? 'opened' : 'hidden'}}"
		mwlResizable
		[ngStyle]="style"
		[enableGhostResize]="true"
		[resizeEdges]="resizeEdges"
		(resizeEnd)="onResizeEnd($event)">
		<div class="tutorial-layer-header {{ selectedTab === 'note' ? 'note-selected' : 'tutorial-selected'}}">
			<h1><span *ngIf="title">{{title}} - </span><span *ngIf="selectedTab === 'tutorial'">{{'Tutorial' | translate}}</span><span *ngIf="selectedTab === 'note'">{{'Note' | translate}}</span></h1>
			<a class="btn btn-icon btn-big-icon {{selectedTab === 'tutorial' ? 'active' : ''}} ml-1" tooltip="Tutorial" placement="{{ this.langIsRTL ? 'right' : 'left' }}" (click)="changeTab('tutorial');"><i class="far fa-circle-question"></i></a>
			<a class="btn btn-icon btn-big-icon {{selectedTab === 'note' ? 'active' : ''}} ml-1" tooltip="Note" placement="{{ this.langIsRTL ? 'right' : 'left' }}" (click)="changeTab('note');"><i class="far fa-file"></i></a>
			<a class="btn btn-icon btn-big-icon ml-1"
			[popover]="positionPopover"
			placement="'left'"
			containerClass="position-popover"
			container="body"
			triggers="click"
			[outsideClick]="true"
			#pop="bs-popover"
			(click)="$event.preventDefault(); $event.stopPropagation();">
				<i class="fas fa-ellipsis-v"></i>
			</a>
			<a class="btn btn-icon btn-big-icon ml-1" tooltip="Close" placement="{{ this.langIsRTL ? 'right' : 'left' }}" (click)="closeTutorial();"><i class="far fa-times closer"></i></a>
		</div>
		<div class="tutorial-layer-content {{ (selectedTab === 'tutorial' && readOnly) ? 'editor-disabled' : ''}}">
			<ckeditor [editor]="Editor" [config]="config" [(ngModel)]="selectedData" (change)="updateModel($event)" [disabled]="(selectedTab === 'tutorial' && readOnly)" (blur)="save($event)"></ckeditor>
		</div>
	</div>

	<ng-template #positionPopover>
		<div class="popover-buttons popover-buttons-bar">
			<a class="btn d-block {{position === 'top' ? 'active' : ''}}" href="#"
				tooltip="{{'Top' | translate}}" placement="right" (click)="$event.preventDefault(); $event.stopPropagation(); pop.hide(); changePosition('top');">
				<i class="fal fa-rectangle-history fa-rotate-180"></i>
			</a>
			<a class="btn d-block {{position === 'right' ? 'active' : ''}}" href="#"
				tooltip="{{'Right' | translate}}" placement="right" (click)="$event.preventDefault(); $event.stopPropagation(); pop.hide(); changePosition('right');">
				<i class="fal fa-rectangle-vertical-history"></i>
			</a>
			<a class="btn d-block {{position === 'bottom' ? 'active' : ''}}" href="#"
				tooltip="{{'Bottom' | translate}}" placement="right" (click)="$event.preventDefault(); $event.stopPropagation(); pop.hide(); changePosition('bottom');">
				<i class="fal fa-rectangle-history"></i>
			</a>
			<a class="btn d-block {{position === 'left' ? 'active' : ''}}" href="#"
				tooltip="{{'Left' | translate}}" placement="right" (click)="$event.preventDefault(); $event.stopPropagation(); pop.hide(); changePosition('left');">
				<i class="fal fa-rectangle-vertical-history fa-rotate-180"></i>
			</a>
		</div>
	</ng-template>
